<template>
<div class="chapter">
<div class="inner_page">
<p class="copya"><a id="page_ii">It’s Not About You, Mr. Easter Bunny</a></p><a id="page_ii">
<p class="copya1"><b>A Love Letter About the True Meaning of Easter</b></p>
<p class="copy">© 2017 Soraya Diase Coffelt. Illustrated by Tea Seroya.</p>
<p class="copyt">All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, scanning, or other,—except for brief quotations in critical reviews or articles, without the prior written permission of the publisher.</p>
</a><p class="copyt"><a id="page_ii">Published in New York, New York, by Morgan James Publishing. Morgan James and The Entrepreneurial Publisher are trademarks of Morgan James, LLC. </a><a href="http://www.MorganJamesPublishing.com" target="_blank">www.MorganJamesPublishing.com</a></p>
<p class="copyt">The Morgan James Speakers Group can bring authors to your live event. For more information or to book an event visit The Morgan James Speakers Group at <a href="http://www.TheMorganJamesSpeakersGroup.com" target="_blank">www.TheMorganJamesSpeakersGroup.com</a>.</p>
<table cellpadding="0" cellspacing="0" class="cop" width="100%">
<colgroup><col width="30%"/>
<col width="70%"/>
</colgroup><tbody><tr>
<td valign="top"><p class="cimage"><img alt="Image" src="images/copy.jpg"/></p></td>
<td valign="top"><p class="copy1">ISBN 978-1-68350-063-6 paperback</p>
<p class="copy1">ISBN 978-1-68350-064-3 eBook</p>
<p class="copy1">ISBN 978-1-68350-065-0 case laminate</p>
<p class="copy1">Library of Congress Control Number:</p>
<p class="copy1">2016907058</p></td>
</tr>
</tbody></table>
<p class="image1"><img alt="Image" src="images/copy1.jpg"/></p>
<p class="copyc">In an effort to support local communities, raise awareness and funds, Morgan James Publishing donates a percentage of all book sales for the life of each book to Habitat for Humanity Peninsula and Greater Williamsburg.</p>
<p class="copyc">Get involved today! Visit<br/><a href="http://www.MorganJamesBuilds.com" target="_blank">www.MorganJamesBuilds.com</a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Copyright01.vue?4e4610fa